module.exports = __webpack_public_path__ + "2945aee653bc9534bdc47e34aefcca2b.svg";